import React, { useRef } from 'react';
import Title from '../../components/Title/Title';
import Timeline from '../../components/Timeline/Timeline';
import useVisiblePage from '../../common/hooks/useVisiblePage';
import { Page } from '../../common/reducers/visible-page/visible-page-types';
var WorkExperience = function () {
    var ref = useRef(null);
    useVisiblePage(ref, Page.EXPERIENCE);
    return (React.createElement("div", { ref: ref, className: 'work-experience' },
        React.createElement("div", { className: 'left-container' },
            React.createElement(Title, { title: 'Work experience', subtitle: '(So far)' }),
            React.createElement("div", { className: 'dots' })),
        React.createElement(Timeline, null)));
};
export default WorkExperience;
